import { Col } from 'reactstrap';
import './index.scss'

const Cards = (props) => {
    return (
        <Col key={props.key} lg={4}>
            <div className="cardsContainer">
                <div>
                    {props.icon}
                </div>
                <h3 dangerouslySetInnerHTML={{ __html: props.title }} />
                <p>
                    {props.des}
                </p>
            </div>
        </Col>
    )
}

export default Cards;